module.exports = __webpack_public_path__ + "images/icons_v2/green-dot-f457ae4b.svg";